import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Cookies from 'js-cookie';
import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';

import Autocomplete from '@material-ui/lab/Autocomplete';
import { FormControl, } from '@mui/material';

import CancelIcon from '@mui/icons-material/Cancel';




import { format, isValid, parse } from 'date-fns';

import IconButton from '@material-ui/core/IconButton';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SaveIcon from '@mui/icons-material/Save';
import {
    Tooltip
} from '@mui/material';
import InputAdornment from "@mui/material/InputAdornment";


import api from '../../../../../../services/api';


import { InputLabel, MenuItem, Select } from "@material-ui/core";







const dropzoneStyles = {
    border: '4px dashed #000000',
    borderRadius: '4px',
    padding: '2px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '2px 0',
};




export default function CadastrarPagamento({ lancamento, closeCadastrarPagamento, attinUpdatePagamento, isEditingPagamento, isUpdatePagamento }) {

    const [inUpdatePagamento, setInUpdatePagamento] = useState(attinUpdatePagamento);


    const [valor, setValor] = useState(isUpdatePagamento ? inUpdatePagamento.valor : 0);

    const [metodosPagamento, setMetodosPagamento] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [instituicoesBancarias, setInstituicoesBancarias] = useState([]);

    const [contasBancarias, setContasBancarias] = useState([]);

    const [fornecedores, setFornecedores] = useState([]);




    function returnDescricaoIb(ib) {
        var texto = "Banco: " + ib.banco +
            "\nAgência: " + ib.agencia +
            "\nConta: " + ib.conta +
            "\nDescrição: " + ib.descricao;
        return texto;


    }





    function returnDescricaoBanco(ib) {

        var texto = "Identificação: " + ib.identificacao +
            "\nTitular: " + ib.titular +
            "\nBanco: " + ib.banco +
            "\nAgência: " + ib.agencia +
            "\nConta: " + ib.conta +
            "\nDescrição: " + ib.descricao +
            "\nPix: " + ib.tipo_chave_1 + "=" + ib.chave_1;
        return texto;


    }






    function returnDescricaoFornecedor(fornecedor) {
        let valor, nome, endereco, texto, identificacao;
        if (isUpdatePagamento) {
            identificacao = fornecedor.tipo_fornecedor === 0 ? "CPF " : "CNPJ"
            valor = fornecedor.tipo_fornecedor === 0 ? fornecedor.cpf : fornecedor.cnpj;

            nome = fornecedor.tipo_fornecedor === 0 ? (fornecedor.nome + " " + fornecedor.sobrenome) :
                (fornecedor.nome_fantasia);

            endereco = fornecedor.logradouro + ", nº " + fornecedor.numero + ", " + fornecedor.bairro + ", " + fornecedor.cidade + " " + fornecedor.estado + " CEP: " + fornecedor.cep;

            texto = "ID: " + fornecedor.id_fornecedor + " " + identificacao + " " + valor + " " + nome + "\n Endereço: " + endereco;
            return texto;
        } else {
            identificacao = fornecedor.tipofornecedor === 0 ? "CPF " : "CNPJ"

            valor = fornecedor.tipofornecedor === 0 ? fornecedor.cpf : fornecedor.cnpj;

            nome = fornecedor.tipofornecedor === 0 ? (fornecedor.nome + " " + fornecedor.sobrenome) :
                (fornecedor.nomefantasia);



            texto = "ID: " + fornecedor.idfornecedor + " " + identificacao + " " + valor + " " + nome + "\n Endereço: " + fornecedor.endereco;
            return texto;
        }
    }


    function returnDescricaoCliente(cliente) {
        let valor, nome, identificacao, endereco, texto;
        if (isUpdatePagamento) {
            identificacao = cliente.tipo_cliente === 0 ? "CPF " : "CNPJ"

            valor = cliente.tipo_cliente === 0 ? cliente.cpf : cliente.cnpj;

            nome = cliente.tipo_cliente === 0 ? (cliente.nome + " " + cliente.sobrenome) :
                (cliente.nome_fantasia);

            endereco = cliente.logradouro + ", nº " + cliente.numero + ", " + cliente.bairro + ", " + cliente.cidade + " " + cliente.estado + " CEP: " + cliente.cep;


            texto = "ID: " + cliente.id_cliente + " " + identificacao + " " + valor + " " + nome + "\n Endereço: " + endereco;
            return texto;
        } else {
            identificacao = cliente.tipocliente === 0 ? "CPF " : "CNPJ"

            valor = cliente.tipocliente === 0 ? cliente.cpf : cliente.cnpj;

            nome = cliente.tipocliente === 0 ? (cliente.nome + " " + cliente.sobrenome) :
                (cliente.nomefantasia);



            texto = "ID: " + cliente.idcliente + " " + identificacao + " " + valor + " " + nome + "\n Endereço: " + cliente.endereco;
            return texto;
        }
    }



    function returnDescricaoMetodoPagamento(metodo) {
        var texto = "Nome: " + metodo.nome +
            " | Codigo: " + metodo.codigo + " | Sigla: " + metodo.sigla + "\nDescrição: " + metodo.descricao;
        return texto;
    }



    async function handleSavePagamento() {
        try {

            var id_user = Cookies.get('id_usuario');

            console.log("Tipo pagador: " + newPagamento.tipo_pagador);


            const parsedDate = parse(newPagamento.data_pagamento, 'dd/MM/yyyy', new Date());
            if (isValid(parsedDate)) {

            } else {
                alert("A data é invalida!");
                return;
            }

            // Validação de hora
            const parsedTime = parse(newPagamento.hora_pagamento, "HH:mm", new Date());
            if (!isValid(parsedTime)) {
                alert("A hora é inválida!");
                return;
            }

            const dataFormatada = format(parse(newPagamento.data_pagamento, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd');



            if (!newPagamento.metodo_pagamento) {
                alert("Selecione o Metodo de Pagamento!");
                console.log("Metodo: " + newPagamento.metodo_pagamento);
                return;
            }


            if (newPagamento.tipo_recebedor === 2) {
                //um fornecedor esta recebendo, precisa especificar a conta
                if (!newPagamento.conta_bancaria) {
                    alert("Selecione a Conta Bancária!");
                    return;
                }
            }



            if (newPagamento.tipo_pagador === 1) {
                //um fornecedor esta recebendo, precisa especificar a conta
                if (!newPagamento.instituicao_bancaria_pagador) {
                    alert("Selecione o Banco de Origem desse pagamento!");
                    return;
                }
            }



            const horaFormatada = format(parsedTime, "HH:mm");


            const cadastro = {

                id_lancamento: lancamento.id_lancamento,
                usuario_criador: { id_usuario: id_user, },
                valor: newPagamento.valor,
                data_pagamento: dataFormatada,
                hora_pagamento: horaFormatada,
                metodo_pagamento: newPagamento.metodo_pagamento,
                tipo_pagador: newPagamento.tipo_pagador,
                tipo_recebedor: newPagamento.tipo_recebedor,
                status: newPagamento.status,
                conta_bancaria: newPagamento.conta_bancaria,
                natureza_pagamento: newPagamento.natureza_pagamento,


            };


            if (newPagamento.tipo_pagador === 0 && newPagamento.cliente_pagador !== null) {

                cadastro.cliente_pagador = { id_cliente: newPagamento.cliente_pagador.idcliente };
            } else if (newPagamento.tipo_pagador === 1 && newPagamento.instituicao_bancaria_pagador !== null) {
                console.log("é um ib que ira pagar!");

                cadastro.instituicao_bancaria_pagador = newPagamento.instituicao_bancaria_pagador;
                console.log("A ie é : " + newPagamento.instituicao_bancaria_pagador);

                console.log("A ie é : " + cadastro.instituicao_bancaria_pagador);

            } else {
                alert("Selecione o Pagador!");
                return;
            }



            if (newPagamento.tipo_recebedor === 0 && newPagamento.cliente_recebedor !== null) {
                cadastro.cliente_recebedor = newPagamento.cliente_recebedor;
            } else if (newPagamento.tipo_recebedor === 1 && newPagamento.instituicao_bancaria_recebedor !== null) {
                cadastro.instituicao_bancaria_recebedor = newPagamento.instituicao_bancaria_recebedor;
            } else if (newPagamento.tipo_recebedor === 2 && newPagamento.fornecedor_recebedor !== null) {
                cadastro.fornecedor_recebedor = { id_fornecedor: newPagamento.fornecedor_recebedor.idfornecedor }
            } else {
                alert("Selecione o Recebedor!");
                return;
            }



            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.post('/v1/protected/financeiro/lancamentos/pagamentos/cadastrar', cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Pagamento Cadastrado!");
                closeCadastrarPagamento();


            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }
        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente!");
        }

    };


    const [newPagamento, setNewPagamento] = useState(null);



    function createNewPagamento(fornecedores) {
        const today = moment().format('DD/MM/YYYY');
        const hora = moment().format('HH:mm');

        let pagador_tipo = 0;
        let recebedor_tipo = 0;

        let dados = {
            valor: 1.0,
            data_pagamento: today,
            hora_pagamento: hora,
            status: 1,
            natureza_pagamento: 0,

        };


        if (lancamento.tipo === 0) {
            //despesa
            pagador_tipo = 1; //uma instituicao bancaria e o pagador
            recebedor_tipo = 2;//um fornecedor é o recebedor



            // recebedor do lancamento é o recebedor de pagamentos
            const fornecedorEncontrado = fornecedores.find(
                (f) => parseInt(f.idfornecedor) === parseInt(lancamento.fornecedor.id_fornecedor)
            );


            if (fornecedorEncontrado) {
                dados.fornecedor_recebedor = fornecedorEncontrado;
                listarContasBancarias(fornecedorEncontrado.idfornecedor);

            }

        } else if (lancamento.tipo === 1) {
            //receita
            pagador_tipo = 0;// um cliente é o pagador
            recebedor_tipo = 1;//uma ib é o recebedor

            dados.cliente_pagador = lancamento.cliente;
        } else if (lancamento.tipo === 2) {
            //emprestimo
        } else if (lancamento.tipo === 3) {
            //transferencia
        }

        dados.tipo_pagador = pagador_tipo;
        dados.tipo_recebedor = recebedor_tipo;





        setNewPagamento(dados);
        setLoading(false);
    }

    const onDropArquivo2 = useCallback(async (acceptedFiles) => {
        // Valida o tipo de arquivo
        // Valida o tipo de arquivo

        console.log("Id parcela in OnDrop: " + inUpdatePagamento.id_pagamento);



        try {
            const formData = new FormData();
            formData.append('arquivos', acceptedFiles[0]);
            formData.append('extensao', acceptedFiles[0].name.split('.').pop());

            const response = await api.post('/v1/protected/financeiro/lancamentos/pagamentos/anexararquivo/' + inUpdatePagamento.id_pagamento + '/' + lancamento.id_lancamento, formData);

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                console.log("arquivo foi enviado");
                closeCadastrarPagamento();



            } else {
                // Lógica a ser executada caso ocorra algum erro durante o salvamento
                console.log("Erro no cadastro_salvo");

            }
        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");
        }
    }, [inUpdatePagamento]);


    const { getRootProps: getRootArquivoProps2, getInputProps: getInputArquivoProps2 } = useDropzone({
        onDrop: onDropArquivo2,
        multiple: false, // Apenas um arquivo pode ser selecionado
        //accept: '.pdf', // Restringe a aceitação apenas para arquivos .pdf

    });


    const [loading, setLoading] = useState(true);

    async function listarInformacoes() {



        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }


            await api.get("v1/protected/financeiro/metodospagamento/listartodos", {
                headers: headers
            }).then(function (response) {


                setMetodosPagamento(response.data)



                api.get("v1/protected/financeiro/instituicaobancaria/listartodos", {
                    headers: headers
                }).then(function (response) {

                    setInstituicoesBancarias(response.data)


                    //buscar fornecedores
                    api.get("v1/protected/fornecedores/listartodossimplificado", {
                        headers: headers
                    }).then(function (response2) {



                        setFornecedores(response2.data);
                        //listar clientes
                        api.get("v1/protected/clientes/listartodossimplificado", {
                            headers: headers
                        }).then(function (response3) {
                            setClientes(response3.data)
                            createNewPagamento(response2.data);

                        });

                    });




                });






            });
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }


    };





    async function listarContasBancarias(id_fornecedor) {



        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }


            await api.get("v1/protected/fornecedores/listarcontasbancarias/" + id_fornecedor, {
                headers: headers
            }).then(function (response) {

                setContasBancarias(response.data);
            });
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }


    };






    useEffect(() => {
        if (!isUpdatePagamento)
            listarInformacoes();
        else
            setLoading(false);


    }, []);





    async function handleUpdatePagamento() {
        try {


            console.log("Tipo pagador: " + inUpdatePagamento.tipo_pagador);


            const parsedDate = parse(inUpdatePagamento.data_pagamento, 'dd/MM/yyyy', new Date());
            if (isValid(parsedDate)) {

            } else {
                alert("A data é invalida!");
                return;
            }

            const dataFormatada = format(parse(inUpdatePagamento.data_pagamento, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd');



            if (!inUpdatePagamento.metodo_pagamento) {
                alert("Selecione o Metodo de Pagamento!");
                console.log("Metodo: " + inUpdatePagamento.metodo_pagamento);
                return;
            }


            if (inUpdatePagamento.tipo_recebedor === 2) {
                //um fornecedor esta recebendo, precisa especificar a conta
                if (!inUpdatePagamento.conta_bancaria) {
                    alert("Selecione a Conta Bancária!");
                    return;
                }
            }





            const cadastro = {

                valor: valor,
                data_pagamento: dataFormatada,
                metodo_pagamento: inUpdatePagamento.metodo_pagamento,
                tipo_pagador: inUpdatePagamento.tipo_pagador,
                tipo_recebedor: inUpdatePagamento.tipo_recebedor,
                status: inUpdatePagamento.status,
                conta_bancaria: inUpdatePagamento.conta_bancaria,


            };


            if (inUpdatePagamento.tipo_pagador === 0 && inUpdatePagamento.cliente_pagador !== null) {

                cadastro.cliente_pagador = inUpdatePagamento.cliente_pagador;
            } else if (inUpdatePagamento.tipo_pagador === 1 && inUpdatePagamento.instituicao_bancaria_pagador !== null) {
                console.log("é um ib que ira pagar!");

                cadastro.instituicao_bancaria_pagador = inUpdatePagamento.instituicao_bancaria_pagador;
                console.log("A ie é : " + inUpdatePagamento.instituicao_bancaria_pagador);

                console.log("A ie é : " + cadastro.instituicao_bancaria_pagador);

            } else {
                alert("Selecione o Pagador!");
                return;
            }



            if (inUpdatePagamento.tipo_recebedor === 0 && inUpdatePagamento.cliente_recebedor !== null) {
                cadastro.cliente_recebedor = inUpdatePagamento.cliente_recebedor;
            } else if (inUpdatePagamento.tipo_recebedor === 1 && inUpdatePagamento.instituicao_bancaria_recebedor !== null) {
                cadastro.instituicao_bancaria_recebedor = inUpdatePagamento.instituicao_bancaria_recebedor;
            } else if (inUpdatePagamento.tipo_recebedor === 2 && inUpdatePagamento.fornecedor_recebedor !== null) {
                cadastro.fornecedor_recebedor = inUpdatePagamento.fornecedor_recebedor;
            } else {
                alert("Selecione o Recebedor!");
                return;
            }



            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.put('/v1/protected/financeiro/lancamentos/pagamentos/atualizar/' + inUpdatePagamento.id_pagamento + '/' + lancamento.id_lancamento, cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Pagamento atualizado!");
                closeCadastrarPagamento();


            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }
        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente! " + _err);
        }

    };


    const handleCancelSavePagamento = () => {
        closeCadastrarPagamento();

    };





    return (
        <div>
            {!loading && (
                <Grid
                    item xs={12}
                    alignItems="center"
                    justifyContent="center"
                    container
                    style={{ marginTop: 10 }}
                    spacing={2}
                >
                    <Grid
                        item
                        xs={12}
                        container
                        alignItems="center"
                        justifyContent="center"
                        style={{ padding: 5 }}
                    >

                        <Grid
                            item
                            xs={4}
                            container
                            alignItems="center"
                            justifyContent="center"
                            style={{ padding: 5 }}
                        >
                            <TextField
                                id="valor"
                                variant="standard"
                                value={isEditingPagamento ? newPagamento.valor : valor}

                                onChange={(e) => {
                                    // Remove tudo que não for dígito ou ponto
                                    let sanitized = e.target.value.replace(/[^0-9.]/g, '');

                                    // Permitir apenas um ponto
                                    const parts = sanitized.split('.');
                                    if (parts.length > 2) {
                                        sanitized = parts[0] + '.' + parts.slice(1).join('');
                                    }

                                    if (isEditingPagamento) {
                                        setNewPagamento({ ...newPagamento, "valor": sanitized });
                                    } else {
                                        setValor(sanitized);
                                    }
                                }}
                                label="Valor"
                                fullWidth
                            />
                        </Grid>

                        <Grid
                            item
                            xs={2}
                            container
                            alignItems="center"
                            justifyContent="center"
                            style={{ padding: 5 }}
                        >
                            <TextField
                                id="data_pagamento"
                                variant="standard"
                                value={isEditingPagamento ? newPagamento.data_pagamento : inUpdatePagamento.data_pagamento}
                                onChange={(e) => {
                                    if (isEditingPagamento) {
                                        setNewPagamento({ ...newPagamento, "data_pagamento": e.target.value })
                                    } else {
                                        setInUpdatePagamento({ ...inUpdatePagamento, "data_pagamento": e.target.value })
                                    }
                                }}
                                label="Data Pagamento"
                                fullWidth

                            />
                        </Grid>

                        <Grid
                            item
                            xs={2}
                            container
                            alignItems="center"
                            justifyContent="center"
                            style={{ padding: 5 }}
                        >
                            <TextField
                                id="hora_pagamento"
                                variant="standard"
                                value={isEditingPagamento ? newPagamento.hora_pagamento : inUpdatePagamento.hora_pagamento}
                                onChange={(e) => {
                                    if (isEditingPagamento) {
                                        setNewPagamento({ ...newPagamento, "hora_pagamento": e.target.value });
                                    } else {
                                        setInUpdatePagamento({ ...inUpdatePagamento, "hora_pagamento": e.target.value });
                                    }
                                }}
                                label="Hora Pagamento"
                                fullWidth
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Tooltip title="Informe a hora do pagamento de acordo com os dados reais para a correta análise do extrato bancário">
                                                <InfoOutlinedIcon color="action" fontSize="small" />
                                            </Tooltip>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>


                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            item xs={4}
                            style={{ padding: 5 }}
                        >
                            <FormControl fullWidth>
                                <InputLabel style={{ fontSize: '14px' }} id="select_stats_pagamento">Status</InputLabel>
                                <Select
                                    labelId="select_stats_pagamento"
                                    id="select_stats_pagamento"
                                    value={isEditingPagamento ? newPagamento.status : inUpdatePagamento.status}
                                    onChange={(e) => {
                                        if (isEditingPagamento) {
                                            setNewPagamento({ ...newPagamento, "status": e.target.value })
                                        } else {
                                            setInUpdatePagamento({ ...inUpdatePagamento, "status": e.target.value })
                                        }
                                    }}
                                    label="Status"
                                    style={{ fontSize: '14px' }}
                                >
                                    <MenuItem style={{ fontSize: '14px' }} value={0}>Há Concluir</MenuItem>
                                    <MenuItem style={{ fontSize: '14px' }} value={1}>Concluído</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>



                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            item xs={12}
                            style={{ padding: 5 }}
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                item xs={12}
                            >

                                <Autocomplete
                                    id="select-metodos-pagamento"
                                    options={metodosPagamento}
                                    fullWidth
                                    getOptionLabel={(metodo) => returnDescricaoMetodoPagamento(metodo).replace(/<br \/>/g, '\n')}
                                    value={isEditingPagamento ? newPagamento.metodo_pagamento : inUpdatePagamento.metodo_pagamento}

                                    onChange={(e, value) => {
                                        if (isEditingPagamento) {
                                            setNewPagamento({ ...newPagamento, "metodo_pagamento": value })
                                        } else {
                                            setInUpdatePagamento({ ...inUpdatePagamento, "metodo_pagamento": value })
                                        }
                                    }}
                                    autoSelect
                                    filterOptions={(options, { inputValue }) => {
                                        const inputKeywords = inputValue.toLowerCase().split(" ");
                                        return options.filter((solicitante) => {
                                            const cotacaoText = returnDescricaoMetodoPagamento(solicitante).toLowerCase();
                                            return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                        });
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label=" Metodo de Pagamento " multiline minRows={2} />
                                    )}
                                    renderOption={(option) => (
                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoMetodoPagamento(option).replace(/\n/g, '<br>') }} />
                                    )}

                                />
                            </Grid>
                        </Grid>





                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            item xs={12}
                            style={{ marginTop: 20, marginBottom: 20, borderRadius: '4px', border: '0.1px solid #000', boxShadow: '0 10px 20px rgba(0, 0, 0, 0.2)' }}
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                item xs={12}
                                style={{ marginTop: 10, marginBottom: 10 }}
                                spacing={2}
                            >
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    item xs={4}
                                    style={{ padding: 5 }}
                                >
                                    <FormControl fullWidth>
                                        <InputLabel style={{ fontSize: '14px' }} id="select_tipo_pagador">Tipo Pagador</InputLabel>
                                        <Select
                                            labelId="select_tipo_pagador"
                                            id="select_tipo_pagador"
                                            value={isEditingPagamento ? newPagamento.tipo_pagador : inUpdatePagamento.tipo_pagador}
                                            onChange={(e) => {
                                                if (isEditingPagamento) {
                                                    setNewPagamento({ ...newPagamento, "tipo_pagador": e.target.value })
                                                } else {
                                                    setInUpdatePagamento({ ...inUpdatePagamento, "tipo_pagador": e.target.value })
                                                }
                                            }}
                                            label="Tipo Pagador"
                                            style={{ fontSize: '14px' }}
                                        >
                                            <MenuItem style={{ fontSize: '14px' }} value={0}>Cliente</MenuItem>
                                            <MenuItem style={{ fontSize: '14px' }} value={1}>Instituição Bancária</MenuItem>
                                            <MenuItem style={{ fontSize: '14px' }} value={2}>Fornecedor</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>


                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    item xs={6}
                                    style={{ padding: 5 }}
                                >
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="center"
                                        alignItems="center"
                                        item xs={12}
                                    >

                                        {
                                            ((isEditingPagamento && newPagamento.tipo_pagador === 0) || (isUpdatePagamento && inUpdatePagamento.tipo_pagador === 0)) &&
                                            <Autocomplete
                                                id="select-cliente-pagador"
                                                options={clientes}

                                                fullWidth
                                                getOptionLabel={(cliente) => returnDescricaoCliente(cliente).replace(/<br \/>/g, '\n')}
                                                value={isEditingPagamento ? newPagamento.cliente_pagador : inUpdatePagamento.cliente_pagador}

                                                onChange={(e, value) => {
                                                    if (isEditingPagamento) {
                                                        setNewPagamento({ ...newPagamento, "cliente_pagador": value })
                                                    } else {
                                                        setInUpdatePagamento({ ...inUpdatePagamento, "cliente_pagador": value })
                                                    }
                                                }}

                                                filterOptions={(options, { inputValue }) => {
                                                    const inputKeywords = inputValue.toLowerCase().split(" ");
                                                    return options.filter((solicitante) => {
                                                        const cotacaoText = returnDescricaoCliente(solicitante).toLowerCase();
                                                        return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                    });
                                                }}
                                                renderInput={(params) => (
                                                    <TextField style={{ fontSize: '14px' }} {...params} label=" Cliente Pagador " multiline minRows={2} />
                                                )}
                                                renderOption={(option) => (
                                                    <div dangerouslySetInnerHTML={{ __html: returnDescricaoCliente(option).replace(/\n/g, '<br>') }} />
                                                )}

                                            />
                                        }

                                        {
                                            ((isEditingPagamento && newPagamento.tipo_pagador === 1) || (isUpdatePagamento && inUpdatePagamento.tipo_pagador === 1)) &&
                                            <Autocomplete
                                                style={{ fontSize: '14px' }}
                                                id="select-cliente-ib"
                                                options={instituicoesBancarias}

                                                fullWidth
                                                getOptionLabel={(ib) => returnDescricaoIb(ib).replace(/<br \/>/g, '\n')}
                                                value={isEditingPagamento ? newPagamento.instituicao_bancaria_pagador : inUpdatePagamento.instituicao_bancaria_pagador}
                                                onChange={(e, value) => {
                                                    if (isEditingPagamento) {
                                                        setNewPagamento({ ...newPagamento, "instituicao_bancaria_pagador": value })
                                                    } else {
                                                        setInUpdatePagamento({ ...inUpdatePagamento, "instituicao_bancaria_pagador": value })
                                                    }
                                                }}


                                                filterOptions={(options, { inputValue }) => {
                                                    const inputKeywords = inputValue.toLowerCase().split(" ");
                                                    return options.filter((solicitante) => {
                                                        const cotacaoText = returnDescricaoIb(solicitante).toLowerCase();
                                                        return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                    });
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} style={{ fontSize: '14px' }} label=" Instituição Bancária Pagadora " multiline minRows={2} />
                                                )}
                                                renderOption={(option) => (
                                                    <div dangerouslySetInnerHTML={{ __html: returnDescricaoIb(option).replace(/\n/g, '<br>') }} />
                                                )}

                                            />


                                        }

                                        <FormControl fullWidth style={{ marginTop: "10px" }}>
                                            <InputLabel id="natureza-label">Origem do Pagamento</InputLabel>
                                            <Select
                                                labelId="natureza-label"
                                                value={isEditingPagamento ? newPagamento.natureza_pagamento ?? 0 : inUpdatePagamento.natureza_pagamento ?? 0}
                                                onChange={(e) => {
                                                    const value = parseInt(e.target.value, 10);
                                                    if (isEditingPagamento) {
                                                        setNewPagamento({ ...newPagamento, "natureza_pagamento": value });
                                                    } else {
                                                        setInUpdatePagamento({ ...inUpdatePagamento, "natureza_pagamento": value });
                                                    }
                                                }}
                                            >
                                                <MenuItem value={0}>Débito</MenuItem>
                                                <MenuItem value={1}>Crédito</MenuItem>
                                            </Select>
                                        </FormControl>

                                    </Grid>
                                </Grid>
                            </Grid>

                        </Grid>




                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            item xs={12}
                            style={{ marginTop: 20, marginBottom: 20, borderRadius: '4px', border: '0.1px solid #000', boxShadow: '0 10px 20px rgba(0, 0, 0, 0.2)' }}
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                item xs={12}
                                style={{ marginTop: 10, marginBottom: 10 }}
                                spacing={2}
                            >
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    align="center"
                                    item xs={4}
                                >
                                    <FormControl fullWidth>
                                        <InputLabel style={{ fontSize: '14px' }} id="select_tipo_recebedor">Tipo Recebedor</InputLabel>
                                        <Select
                                            labelId="select_tipo_recebedor"
                                            id="select_tipo_recebedor"
                                            value={isEditingPagamento ? newPagamento.tipo_recebedor : inUpdatePagamento.tipo_recebedor}
                                            onChange={(e) => {
                                                if (isEditingPagamento) {
                                                    setNewPagamento({ ...newPagamento, "tipo_recebedor": e.target.value })
                                                } else {
                                                    setInUpdatePagamento({ ...inUpdatePagamento, "tipo_recebedor": e.target.value })
                                                }
                                            }}

                                            label="Tipo Recebedor"
                                            style={{ fontSize: '14px' }}
                                        >
                                            <MenuItem style={{ fontSize: '14px' }} value={0}>Cliente</MenuItem>
                                            <MenuItem style={{ fontSize: '14px' }} value={1}>Instituição Bancária</MenuItem>
                                            <MenuItem style={{ fontSize: '14px' }} value={2}>Fornecedor</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    align="center"
                                    item xs={6}
                                >
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="center"
                                        align="center"
                                        item xs={12}
                                    >


                                        {

                                            ((isEditingPagamento && newPagamento.tipo_recebedor === 1) || (isUpdatePagamento && inUpdatePagamento.tipo_recebedor === 1)) &&
                                            <Autocomplete
                                                style={{ fontSize: '14px' }}
                                                id="select-cliente-ib"
                                                options={instituicoesBancarias}

                                                fullWidth
                                                getOptionLabel={(ib) => returnDescricaoIb(ib).replace(/<br \/>/g, '\n')}
                                                value={isEditingPagamento ? newPagamento.instituicao_bancaria_recebedor : inUpdatePagamento.instituicao_bancaria_recebedor}
                                                onChange={(e, value) => {
                                                    if (isEditingPagamento) {
                                                        setNewPagamento({ ...newPagamento, "instituicao_bancaria_recebedor": value })
                                                    } else {
                                                        setInUpdatePagamento({ ...inUpdatePagamento, "instituicao_bancaria_recebedor": value })
                                                    }
                                                }}


                                                filterOptions={(options, { inputValue }) => {
                                                    const inputKeywords = inputValue.toLowerCase().split(" ");
                                                    return options.filter((solicitante) => {
                                                        const cotacaoText = returnDescricaoIb(solicitante).toLowerCase();
                                                        return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                    });
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} style={{ fontSize: '14px' }} label=" Instituição Bancária Recebedora " multiline minRows={2} />
                                                )}
                                                renderOption={(option) => (
                                                    <div dangerouslySetInnerHTML={{ __html: returnDescricaoIb(option).replace(/\n/g, '<br>') }} />
                                                )}

                                            />
                                        }


                                        {
                                            ((isEditingPagamento && newPagamento.tipo_recebedor === 2) || (isUpdatePagamento && inUpdatePagamento.tipo_recebedor === 2)) &&
                                            <Autocomplete
                                                id="select-fornecedor-recebedor"
                                                options={fornecedores}

                                                fullWidth
                                                style={{ fontSize: '14px' }}
                                                getOptionLabel={(fornecedor) => returnDescricaoFornecedor(fornecedor).replace(/<br \/>/g, '\n')}
                                                value={isEditingPagamento ? newPagamento.fornecedor_recebedor : inUpdatePagamento.fornecedor_recebedor}
                                                onChange={(e, value) => {
                                                    if (isEditingPagamento) {
                                                        setNewPagamento({ ...newPagamento, "fornecedor_recebedor": value })
                                                    } else {
                                                        setInUpdatePagamento({ ...inUpdatePagamento, "fornecedor_recebedor": value })
                                                    }
                                                }}
                                                filterOptions={(options, { inputValue }) => {
                                                    const inputKeywords = inputValue.toLowerCase().split(" ");
                                                    return options.filter((solicitante) => {
                                                        const cotacaoText = returnDescricaoFornecedor(solicitante).toLowerCase();
                                                        return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                    });
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} style={{ fontSize: '14px' }}
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            style: { fontSize: '14px' }, // Definindo o tamanho do texto aqui
                                                        }}
                                                        InputLabelProps={{
                                                            style: { fontSize: '14px' }, // Definindo o tamanho do texto do rótulo aqui
                                                        }}
                                                        label=" Fornecedor Recebedor " multiline minRows={2}
                                                    />
                                                )}



                                            />
                                        }



                                    </Grid>
                                </Grid>


                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    align="center"
                                    item xs={6}
                                >
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="center"
                                        align="center"
                                        item xs={12}
                                    >

                                        {
                                            ((isEditingPagamento && newPagamento.tipo_recebedor === 2) || (isUpdatePagamento && inUpdatePagamento.tipo_recebedor === 2)) &&
                                            <Autocomplete
                                                id="select-fornecedor-recebedor"
                                                options={isEditingPagamento ? contasBancarias : inUpdatePagamento.fornecedor_recebedor.contas_bancarias}

                                                fullWidth
                                                style={{ fontSize: '14px' }}
                                                getOptionLabel={(conta) => returnDescricaoBanco(conta).replace(/<br \/>/g, '\n')}
                                                value={isEditingPagamento ? newPagamento.conta_bancaria : inUpdatePagamento.conta_bancaria}
                                                onChange={(e, value) => {
                                                    if (isEditingPagamento) {
                                                        setNewPagamento({ ...newPagamento, "conta_bancaria": value })
                                                    } else {
                                                        setInUpdatePagamento({ ...inUpdatePagamento, "conta_bancaria": value })
                                                    }
                                                }}
                                                filterOptions={(options, { inputValue }) => {
                                                    const inputKeywords = inputValue.toLowerCase().split(" ");
                                                    return options.filter((solicitante) => {
                                                        const cotacaoText = returnDescricaoBanco(solicitante).toLowerCase();
                                                        return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                    });
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} style={{ fontSize: '14px' }}
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            style: { fontSize: '14px' }, // Definindo o tamanho do texto aqui
                                                        }}
                                                        InputLabelProps={{
                                                            style: { fontSize: '14px' }, // Definindo o tamanho do texto do rótulo aqui
                                                        }}
                                                        label=" Conta Bancária do Recebedor " multiline minRows={2}
                                                    />
                                                )}



                                            />
                                        }



                                    </Grid>
                                </Grid>





                            </Grid>
                        </Grid>

                        {isUpdatePagamento &&
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-end"
                                align="flex-end"
                                item xs={8}
                                style={{ marginTop: 5 }}
                            >


                                <div {...getRootArquivoProps2()} style={dropzoneStyles}>
                                    <input {...getInputArquivoProps2()} />
                                    <Typography align="center" variant="h7">
                                        Anexo
                                    </Typography>
                                </div>


                            </Grid>
                        }




                    </Grid>
                    <Grid
                        item
                        xs={12}
                        container
                        alignItems="center"
                        justifyContent="center"
                        spacing={2}
                        style={{ marginTop: 5 }}
                    >
                        <IconButton color="success" onClick={isEditingPagamento ? handleSavePagamento : handleUpdatePagamento} >
                            <SaveIcon />
                        </IconButton>
                        <IconButton color="error" onClick={() => handleCancelSavePagamento()} >
                            <CancelIcon />
                        </IconButton>
                    </Grid>
                </Grid>

            )
            }




        </div>
    );
}



